// extracted by mini-css-extract-plugin
export var btn = "mail-module--btn--33185";
export var item = "mail-module--item--33550";
export var mail = "mail-module--mail--6f06a";
export var photo = "mail-module--photo--ec3ad";
export var row = "mail-module--row--2f3d1";
export var text = "mail-module--text--36e95";